import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-carrier-list',
  templateUrl: './carrier-list.component.html',
  styleUrls: ['./carrier-list.component.css']
})
export class CarrierListComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_carrierslist_grid')
                .setLoadDataFunction({
                    method: 2664,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'carrierlist_create_new',
                    text: 'carrierlist_create_new',
                    func: () => this.stateService?.go('carrier', { carrier_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('carrierList', {
//        templateUrl: 'views/components/views/carrierList/carrierList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_carrierslist_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 2664,
//                parameters: {}
//            }).setCustomToolbarButtons([{
//                name: 'carrierlist_create_new',
//                text: 'carrierlist_create_new',
//                func: () => stateService.go('carrier', { carrier_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
